export default "__VITE_PUBLIC_ASSET__58460207__"